export const business = {
  name: "Ganic Wellness",
  logo: "/ganicwellness/ganiclogo.png",
  tagline: "Experience true bliss",
  phoneDisplay: "0406 393 199",
  phoneHref: "tel:+61406393199",
  email: "ganicwellnessspa@gmail.com",
  address: "Unit 8/910 Albany Hwy, East Victoria Park, Perth, WA 6101",
  mapHref:
    "https://maps.google.com/?q=Unit+8/910+Albany+Hwy,+East+Victoria+Park,+Perth,+WA+6101",
  bookingUrl: "https://www.caljn.com/business/ganic-wellness-and-massage",
};

export const hours = [
  { day: "Monday", time: "9:00am – 10:00pm" },
  { day: "Tuesday", time: "9:00am – 10:00pm" },
  { day: "Wednesday", time: "9:00am – 10:00pm" },
  { day: "Thursday", time: "9:00am – 10:00pm" },
  { day: "Friday", time: "9:00am – 10:00pm" },
  { day: "Saturday", time: "9:00am – 10:00pm" },
  { day: "Sunday", time: "9:00am – 10:00pm" },
];

export const policies = [
  {
    title: "Rescheduling",
    detail:
      "Give us at least 6 hours' notice to cancel or move your appointment, free of charge.",
  },
  {
    title: "Late cancellation",
    detail:
      "Cancelling inside 6 hours of your appointment is charged at 50% of the service fee.",
  },
  {
    title: "No-shows",
    detail:
      "A missed appointment without notice is charged at the full service fee.",
  },
  {
    title: "Arriving late",
    detail:
      "Sessions finish at the originally booked time, so the next guest isn't delayed — full price applies.",
  },
];

export const services = [
  {
    id: "remedial-massage",
    name: "Remedial & Sports Massage",
    summary:
      "Targeted, therapeutic work for chronic tension, injury recovery and everyday overuse — claimable through most private health funds.",
    details: [
      "Deep tissue & trigger point therapy",
      "Sports massage & mobility work",
      "Myofascial cupping & Gua Sha",
      "Lymphatic drainage",
    ],
  },
  {
    id: "relaxation-massage",
    name: "Relaxation & Swedish Massage",
    summary:
      "Slower, flowing strokes designed to ease the nervous system down and let the day go.",
    details: [
      "Swedish & relaxation massage",
      "Thai massage",
      "Reflexology",
      "Pregnancy massage",
    ],
  },
  {
    id: "facial-treatments",
    name: "Facial Treatments",
    summary:
      "Skin-first facials suited to your skin type, from deep cleansing to targeted anti-ageing care.",
    details: [
      "Deep cleansing facials",
      "Anti-ageing treatments",
      "Customised facials",
    ],
  },
  {
    id: "body-treatments",
    name: "Body Treatments",
    summary:
      "Exfoliating, hydrating rituals that leave skin soft from shoulders to feet.",
    details: [
      "Sugar scrub",
      "Detoxifying body wrap",
      "Hydrating body butter treatment",
    ],
  },
  {
    id: "waxing",
    name: "Waxing",
    summary:
      "Considerate, precise waxing for men and women, from brows to Brazilian.",
    details: [
      "Brazilian & bikini waxing",
      "Eyebrow shaping",
      "Full body waxing",
    ],
  },
];

export const team = [
  {
    name: "Gelma",
    years: "14 years experience",
    bio: "A warm, detail-focused therapist who shapes every session around circulation, detox and muscle recovery.",
    specialties: [
      "Deep tissue & trigger point",
      "Lymphatic drainage & sculpting",
      "Pregnancy massage",
      "Reflexology",
      "Myofascial cupping & Gua Sha",
      "Facial therapy",
    ],
    availability: "7 days a week, 9am – 9pm",
  },
  // {
  //   name: "Cici",
  //   years: "Traditional & sports specialist",
  //   bio: "Originally from Bhutan, Cici brings deep experience in Thai and sports massage, with a calm, welcoming manner.",
  //   specialties: [
  //     "Traditional Chinese & Thai massage",
  //     "Swedish massage & reflexology",
  //     "Deep tissue & remedial",
  //     "Acupressure",
  //   ],
  //   availability: "Fri – Sun, 9am – 5pm",
  // },
  // {
  //   name: "ZsaZsa",
  //   years: "9 years in fitness & rehab",
  //   bio: "A personal trainer and stretch therapist studying physiotherapy, focused on rehabilitation, mobility and performance.",
  //   specialties: [
  //     "Trigger point & deep tissue",
  //     "Sports massage & mobility",
  //     "Injury rehabilitation",
  //     "Lymphatic drainage",
  //   ],
  //   availability: "Wed – Thu, 2pm – 9pm",
  // },
  // {
  //   name: "An",
  //   years: "2 years experience",
  //   bio: "Tailors every treatment closely to the client in front of her, with a gentle, trust-building approach.",
  //   specialties: [
  //     "Deep tissue & trigger point",
  //     "Lymphatic drainage",
  //     "Relaxation & sports massage",
  //     "Reflexology & fascia release",
  //   ],
  //   availability: "By appointment",
  // },
];

export const aboutHighlights = [
  {
    title: "Our policy",
    image: "/ganicwellness/ganic2.jpg",
    body: policies.map((p) => p.detail),
  },
  {
    title: "Private Health Fund Rebate",
    image: "/ganicwellness/ganic3.jpg",
    body: "Our therapists are dedicated to delivering exceptional care, and all our remedial treatments are eligible for private health insurance claims — making it easier to prioritise your wellbeing.",
  },
  {
    title: "Our facilities",
    image: "/ganicwellness/bg3.jpg",
    body: "We believe the environment plays a crucial role in the spa experience, so every space — from the waiting area to each private treatment room — is designed for comfort and calm.",
  },
];

export const memberships = [
  {
    tier: "Silver",
    subtitle: "Relaxation & rejuvenation",
    forWhom: "Stress relief and an easy, ongoing self-care rhythm.",
    plans: [
      {
        name: "Silver 1",
        detail: "5 massage sessions + a free scrub or 30-min massage",
        price: "$449",
      },
      {
        name: "Silver 2",
        detail: "10 massage sessions + a free 60-min massage",
        price: "$899",
      },
    ],
    perks: [
      "Therapeutic sessions to ease tension",
      "One bonus treatment included",
    ],
    note: "Therapist selection isn't available on Silver.",
  },
  {
    tier: "Gold",
    subtitle: "Deep tissue & lymphatic drainage",
    forWhom: "Deeper healing, tension relief and better circulation.",
    plans: [
      {
        name: "Gold 1",
        detail: "5 sessions + a free scrub or 30-min massage",
        price: "$509",
      },
      {
        name: "Gold 2",
        detail: "10 sessions + a free 60-min massage",
        price: "$999",
      },
    ],
    perks: ["Choose your preferred therapist", "Free upgrade to organic oils"],
    note: "Memberships can be shared with family, a friend or a partner.",
  },
];

export const qualifications = [
  "Diploma of Remedial Massage",
  "Certificate V in Massage Therapy Practice",
  "Degree in Physiotherapy & Manual Therapy",
  "Diploma/Degree in Beauty Therapy",
  "Certified Dry Needling & Myofascial Cupping Practitioner",
  "Certificate in Thai Massage",
];

export const whyChoose = [
  {
    title: "Qualified & experienced",
    detail:
      "Every therapist on our team is certified, insured and genuinely experienced in their craft.",
  },
  {
    title: "Health fund rebates",
    detail:
      "Most remedial treatments are claimable through private health insurance.",
  },
  {
    title: "Personalised care",
    detail:
      "Every session is shaped around your body, your goals and how you're feeling that day.",
  },
  {
    title: "A calm space",
    detail:
      "From the waiting area to the treatment rooms, the space is built for you to switch off.",
  },
];
